import { Form, FormAnswer } from '@models/membership/Form'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_FORM_ANSWERS_URL } from '@utils/urls'

const fetchFormAnswers = (params: TableParams) =>
  SBAPI.FetchPaginated<FormAnswer[]>(MEMBERSHIP_FORM_ANSWERS_URL, params)

const fetchFormAnswersForEntity = (
  entity: 'subscription' | 'membership-profile',
  id: number
) =>
  SBAPI.Fetch<Form>(`${MEMBERSHIP_FORM_ANSWERS_URL}/by-entity`, { entity, id })

export { fetchFormAnswers, fetchFormAnswersForEntity }
